<template>
  <div id="layout">
    <iframe
      id="viewer"
      src=""
      scrolling="no"
      frameborder="0"
      width="100%"
      class="fill-height"
    />
    <header-product v-if="isProductLoaded" />
    <glance-options-item v-if="this.$vuetify.breakpoint.smAndUp && isGlancedOptionsItem" />
    <alert-error />
    <gamepad
      v-if="isProductLoaded"
      @arClick="$emit('arClick')"
      @resetClick="$emit('resetClick')"
      @dimensionsClick="$emit('dimensionsClick')"
      @screenshotClick="$emit('screenshotClick')"
    />
  </div>
</template>

<script>
  import AlertError from '../alerts/AlertError.vue'
  import HeaderProduct from '../headers/HeaderProduct.vue'
  import GlanceOptionsItem from '../glances/GlanceOptionsItem.vue'
  import Gamepad from '../gamepad/Gamepad.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Viewer',

    components: {
      AlertError,
      HeaderProduct,
      GlanceOptionsItem,
      Gamepad,
    },

    computed: {
      ...mapGetters(['isProductLoaded', 'isGlancedOptionsItem']),
    },
  }
</script>

<style scoped>
#layout {
  position: relative;
  width: 100%;
}
</style>
